import React, { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { ReactComponent as MenuIconWhite } from '../../../../assets/icons/MenuDots.svg';
import { ReactComponent as MenuIconBlack } from '../../../../assets/icons/MenuDotsB.svg';
import { PanelWithDetails } from '../../../../api/panels';
import { ReactComponent as ListIcon } from '../../../../assets/icons/list.svg';
import './PanelsTable.scss';

type Props = {
  panelData: PanelWithDetails;
  onViewPanel: (panel: PanelWithDetails) => void;
  onEditPanel: (panel: PanelWithDetails) => void;
  onDeletePanel: (panelId: number) => void;
};

const PanelsTableRow: React.FC<Props> = ({ panelData, onViewPanel, onEditPanel, onDeletePanel }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const onOptionClick = (action: string) => {
    if (action === 'view') {
      onViewPanel(panelData);
    } else if (action === 'edit') {
      onEditPanel(panelData);
    } else if (action === 'delete') {
      onDeletePanel(panelData.id);
    }
    setIsMenuOpen(false);
  };

  const actionMenuStyles = {
    backgroundColor: isMenuOpen ? '#238698' : 'transparent',
  };

  const onMenuIconClick = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen((prev) => !prev);
  };

  const formatPrice = (price: number | null | undefined): string => {
    if (price === null || price === undefined) return '-';
    return `${price.toFixed(2)}`;
  };

  return (
    <div className='table-row'>
      <div className='table-cell panel-name'>
        {panelData.name || '-'}
      </div>
      <div className='table-cell'>
        {panelData.catalog_id || '-'}
      </div>
      <div className='table-cell'>
        {panelData.body_systems && panelData.body_systems.length > 0
          ? panelData.body_systems.map(bs => bs.title).join(', ')
          : '-'
        }
      </div>
      <div className='table-cell biomarkers'>
        {panelData.biomarkers && panelData.biomarkers.length > 0
          ? panelData.biomarkers.map(bm => bm.name).join(', ')
          : '-'
        }
      </div>
      <div className='table-cell'>
        {formatPrice(panelData.price)}
      </div>
      <div className='table-cell'>
        {formatPrice(panelData.non_discounted_price ?? panelData.non_discounted_price)}
      </div>
      <div className='table-cell actions'>
        <OutsideClickHandler onOutsideClick={() => setIsMenuOpen(false)}>
          <div className='action-menu-container'>
            <div className='menu-btn' style={actionMenuStyles}>
              {isMenuOpen ? (
                <MenuIconWhite onClick={(e) => onMenuIconClick(e)} />
              ) : (
                <MenuIconBlack onClick={(e) => onMenuIconClick(e)} />
              )}
            </div>
            {isMenuOpen && (
              <div className='action-menu'>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onOptionClick('view');
                  }}
                  className='option'
                >
                   <ListIcon />
                   View/Edit
                </div>
              </div>
            )}
          </div>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default PanelsTableRow;

